module.exports = {
  'introduction': ['/en/axes/performance/introduction/','/fr/opere/performance/introduzione/'],
  'performance01': ['/en/axes/performance/performance01/','/fr/opere/performance/performance01/'],
  'performance02': ['/en/axes/performance/performance02/', '/fr/opere/performance/performance02/'],
  'performance03': ['/en/axes/performance/performance03/', '/fr/opere/performance/performance03/'],
  'performance04': ['/en/axes/performance/performance04/', '/fr/opere/performance/performance04/'],
};
